import "core-js/modules/es6.regexp.to-string";
import CryptoJS from 'crypto-js';
export default {
  // 加密
  encrypt: function encrypt(word, keyStr) {
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var encryptedData = CryptoJS.AES.encrypt(word, key, {
      iv: key,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    encryptedData = encryptedData.ciphertext.toString();
    // console.log('加密后-no-hex：' + encryptedData)
    return encryptedData;
  },
  // 解密
  decrypt: function decrypt(word, keyStr) {
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    var encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    var decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
      iv: key,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    var decryptedStr = decryptedData.toString(CryptoJS.enc.Utf8);
    return decryptedStr;
  }
};